// extracted by mini-css-extract-plugin
export default {"blockTitle":"Title_blockTitle__Tprpy","titleLine":"Title_titleLine__LycKP","titleBox":"Title_titleBox__96z9K","blockText":"Title_blockText__4q3Lm"};